import { axiosInstance } from '../App';
import { DeductibleConceptDTO, DeductibleConceptRequestDTO } from '../dto/DeductibleConceptDTO';

const BASE = '/api/secured/deductible-concepts';

/** Conceptos de la sede, activos e inactivos, ordenados por descripción. Pocos: sin paginación. */
export function getDeductibleConcepts(): Promise<DeductibleConceptDTO[]> {
    return axiosInstance.get(BASE).then(r => r.data ?? []);
}

export function createDeductibleConcept(body: DeductibleConceptRequestDTO): Promise<DeductibleConceptDTO> {
    return axiosInstance.post(BASE, body).then(r => r.data);
}

export function updateDeductibleConcept(id: number, body: DeductibleConceptRequestDTO): Promise<DeductibleConceptDTO> {
    return axiosInstance.put(`${BASE}/${id}`, body).then(r => r.data);
}
